// Stateless readers for the <meta> build-identity tags in index.html. The deploy workflow
// substitutes the __BUILD_*__ placeholders after the build, so an unresolved token, or a
// missing or empty tag, reads as unknown (dev). Shared here so the shell and the admin
// remote parse the tags identically without importing across the MF boundary.

export function readBuildMeta(name: string): string | undefined {
    if (typeof document === 'undefined') return undefined;
    const content = document.querySelector(`meta[name="${name}"]`)?.getAttribute('content')?.trim();
    // Empty, missing, or an unsubstituted placeholder → treat as unknown (dev).
    if (!content || content.startsWith('__')) return undefined;
    return content;
}

export function readBuildMetaNumber(name: string): number | undefined {
    const raw = readBuildMeta(name);
    if (raw === undefined) return undefined;
    const n = Number(raw);
    return Number.isFinite(n) ? n : undefined;
}
